export const CANTIDAD_ANIOS_DESPLEGABLE = 100;
export const FORMATO_FECHA_INPUT_DEFAULT = "dd/MM/yyyy";

export function normalizarFormatoFechaInput(formato) {
  if (Array.isArray(formato)) {
    return formato.map(normalizarFormatoFechaInput);
  }

  if (typeof formato !== "string") return formato;

  return formato.replace(/-/g, "/");
}

export function normalizarValorFechaInput(valor) {
  if (typeof valor !== "string") return valor;

  const valorConBarras = valor.replace(/-/g, "/");
  const fechaSinSeparadores = valorConBarras.match(
    /^(\d{2})(\d{2})(\d{4})(.*)$/,
  );

  if (!fechaSinSeparadores) return valorConBarras;

  const [, dia, mes, anio, resto] = fechaSinSeparadores;
  return `${dia}/${mes}/${anio}${resto}`;
}

export function normalizarEventoFechaInput(evento) {
  if (typeof evento?.target?.value !== "string") return;

  evento.target.value = normalizarValorFechaInput(evento.target.value);
}

export function parseFechaMinimaInput(valor) {
  if (valor instanceof Date) {
    return Number.isNaN(valor.getTime()) ? undefined : valor;
  }

  if (typeof valor !== "string") return undefined;

  const partes = valor.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!partes) return undefined;

  const [, diaTexto, mesTexto, anioTexto] = partes;
  const dia = Number(diaTexto);
  const mes = Number(mesTexto);
  const anio = Number(anioTexto);
  const fecha = new Date(anio, mes - 1, dia);

  if (
    fecha.getFullYear() !== anio ||
    fecha.getMonth() !== mes - 1 ||
    fecha.getDate() !== dia
  ) {
    return undefined;
  }

  return fecha;
}

export function resolverFechaMinimaInput(fechaMinima, minDate) {
  const fechaConfigurada = parseFechaMinimaInput(fechaMinima);
  const fechaExistente = parseFechaMinimaInput(minDate);

  if (!fechaConfigurada) return minDate;
  if (!fechaExistente) return fechaConfigurada;

  return fechaConfigurada > fechaExistente ? fechaConfigurada : fechaExistente;
}
